import { render, staticRenderFns } from "./KChart.vue?vue&type=template&id=6dad38a7&scoped=true"
import script from "./KChart.vue?vue&type=script&setup=true&lang=js"
export * from "./KChart.vue?vue&type=script&setup=true&lang=js"
import style0 from "./KChart.vue?vue&type=style&index=0&id=6dad38a7&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6dad38a7",
  null
  
)

export default component.exports